<template>
  <com-popup v-if="show">

    <section style="max-width:90%;padding:0.20rem 0.74rem;background: #fff;border-radius: 0.32rem;max-height: 90%;" >

      <div @click="btnClose" style="width:0.36rem;height:0.36rem;position: absolute;right:0.38rem;top:0.42rem;">
        <img src="@/assets/close.png" full>
      </div>

      <hgroup class="flex-row flex-cross-center">
        <div style="width:0.63rem;height:0.63rem;">
          <img src="@/assets/loan-banner2-icon1.png" full>
        </div>
        <h1 style="margin-left:28px" class="font-36" color-title>Pinjaman Staff</h1>
      </hgroup>


      <section class="flex-row" style="margin-top: 0.24rem;">

        <section class="pop flex-col" style="width:50%">
          <hgroup>
            <h4 color-title> Proses Pinjaman: </h4>
            <h4 color-small-title>Online</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Dokumen yang diperlukan；</h4>
            <h4 color-small-title>KTP</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Jaminan / Agunan:</h4>
            <h4 color-small-title>Tidak ada</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Jumlah Pinjaman:</h4>
            <h4 color-small-title>Rp400.000 - Rp4.000.000</h4>
          </hgroup>

          <hgroup>
            <h6 color-small-title>Apabila Peminjam telah memenuhi kewajibannya hingga Pinjaman ke-4 (Empat), atau Empat Kali Pinjaman TANPA CATATAN, maka Peminjam secara Otomatis akan masuk kategori Kartu Platinum</h6>
          </hgroup>
          <hgroup>
            <h6 color-small-title>Apabila Peminjam telah memenuhi kewajibannya hingga Pinjaman ke-7 (Tujuh), atau Tujuh Kali Pinjaman TANPA CATATAN, maka Peminjam secara Otomatis akan masuk kategori Kartu Black</h6>
          </hgroup>
        </section>

        <section class='pop' style="margin-left: 0.18rem;width:50%">
          <hgroup>
            <h4 color-title>Batas waktu pinjaman:</h4>
            <h4 color-small-title>21 - 180 hari</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Lama proses dari awal pengajuan:</h4>
            <h4 color-small-title>15 menit</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Proses pembayaran:</h4>
            <h4 color-small-title>Via online dengan berbagai macam metode pembayaran melalui perbankan</h4>
            <h4 color-small-title>dan waralaba seperti Alfamart</h4>
            <h4 color-small-title>Proses pembayaran melalui rekening escrow</h4>
          </hgroup>

          <hgroup>
            <h4 color-title>Perincian bunga:</h4>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title>Bunga:</h4>
              <h4 color-small-title>0,02% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title>Penilaian Resiko:</h4>
              <h4 color-small-title>0,1% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title>Mitigasi Resiko:</h4>
              <h4 color-small-title>0,25% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title>Pengembalian / Komisi:</h4>
              <h4 color-small-title>0,15% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title> Pengumpulan:</h4>
              <h4 color-small-title>0,1% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title> Resiko Hukum:</h4>
              <h4 color-small-title>0,18% per hari</h4>
            </hgroup>

            <hgroup class="flex-row flex-cross-center">
              <h4 color-title>TOTAL:</h4>
              <h4 color-title>0,8% per hari</h4>
            </hgroup>
          </hgroup>
        </section>


      </section>



    </section>
  </com-popup>
</template>
<script>

import comPopup from '@/components/comPopup';

export default {
  mixins: [],
  name: "com-popup-help",
  computed: {
  },
  data() {
    return {
      title:"",
      textLeft:"",
      textRight:"",
      show:false,
    };
  },
  methods: {
    btnClose(){
      this.show=false;
    },
    open(title,left,right){
      this.title=title;
      this.textLeft=left;
      this.textRight=right;
      this.show=true;
    }
  },
  components: {
    comPopup
  }
};

</script>
<style scoped lang="scss">
hgroup{
  margin-top:0.22rem;
}

</style>
